import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdDiarioObras: number;
  ResponsavelPesquisa: number;
  FornecedorPesquisa: number;
  ClientePesquisa: number;
  status: number;
  pesquisa: string | Date | number | null;
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  TipoStatus: number;
  TipoTempo: number;
  TipoDiaPraticavel: number;
  dataReceberDe: Date | null,
  dataReceberAte: Date | null,
  SomentePendentes: boolean | null,
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setResponsavelPesquisa: SetFunction<number>;
  setFornecedorPesquisa: SetFunction<number>;
  setClientePesquisa: SetFunction<number>;
  setStatus: SetFunction<number>;
  setPesquisa: SetFunction<string | Date | number | null>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
  setTipoStatus: SetFunction<number>;
  setTipoTempo: SetFunction<number>;
  setTipoDiaPraticavel: SetFunction<number>;
  setSomentePendentes: SetFunction<boolean>;
};

export const initialFiltersValues: State = {
  IdDiarioObras: 0,
  ResponsavelPesquisa: 0,
  FornecedorPesquisa: 0,
  ClientePesquisa: 0,
  pesquisa: "",
  status: 0,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
  TipoTempo: 0,
  TipoDiaPraticavel: 0,
  dataReceberDe: null,
  dataReceberAte: null,
  SomentePendentes: false,
  TipoStatus: 3,
};

export const useDiarioObrasFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setClientePesquisa: (vfn) => SetFunctionImpl(set, 'ClientePesquisa', vfn),
  setTipoStatus: (vfn) => SetFunctionImpl(set, 'TipoStatus', vfn),
  setTipoTempo: (vfn) => SetFunctionImpl(set, 'TipoTempo', vfn),
  setTipoDiaPraticavel: (vfn) => SetFunctionImpl(set, 'TipoDiaPraticavel', vfn),
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setResponsavelPesquisa: (vfn) => SetFunctionImpl(set, 'ResponsavelPesquisa', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  setSomentePendentes: (vfn) => SetFunctionImpl(set, 'SomentePendentes', vfn),

  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));